import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import SimpleInput from '../SimpleInput/SimpleInput'
import Modal from 'src/components/Modal'
import * as S from './RestockingConfirmationModal.styles'

interface RestockingConfirmationModalProps {
  show: boolean
  title: string
  dataTestId: string
  onConfirm: () => void
  onReject: () => void
}

interface FormData {
  addressCode: string;
}

const RestockingConfirmationModal: React.FC<RestockingConfirmationModalProps> = ({
  show,
  title,
  dataTestId,
  onConfirm,
  onReject,
}) => {
  const [fifoCompleted, setFifoCompleted] = useState(false)
  const { user, currentProductToRestock, isRestockAddressValid } = useSelector((state) => state.restocking)
  const { fc, validateFc } = useFulfillmentCenter()
  const {
    register,
    getValues,
    reset,
    formState: { errors },
  } = useForm<FormData>()

  const dispatch = useDispatch()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  const validateAddress = () => {
    if (!currentProductToRestock) return

    const addressCode = getValues('addressCode').trim()

    dispatch(actions.restockingValidateRestockAddress({
      badge: user.badge,
      idPageItem: currentProductToRestock.idPageItem,
      address: addressCode,
      isGondola: currentProductToRestock.location.isGondola,
      idFulfillmentCenter: fc.id,
      onFail: () => reset({ addressCode: '' }),
    }))
  }

  const handleFifoChange = (event: React.ChangeEvent<HTMLInputElement>) => setFifoCompleted(event.target.checked)

  const closeModal = () => {
    setFifoCompleted(false)
    reset({ addressCode: '' })
    onReject()
    dispatch(actions.clearProperty('isRestockAddressValid'))
  }

  useEffect(() => {
    if (isRestockAddressValid && !show) {
      setFifoCompleted(false)
      reset({ addressCode: '' })
      dispatch(actions.clearProperty('isRestockAddressValid'))
    }
  }, [dispatch, reset, isRestockAddressValid, show])

  return (
    <Modal
      show={show}
      testId={dataTestId}
      centered
      title={title}
      closedButton={false}
      body={(
        <S.Container>
          <>
            <Typography variant='body1' style={{ fontWeight: 900 }}>Bipe o endereço de reposição.</Typography>
            <S.ContainerInput>
              <SimpleInput
                onSubmit={validateAddress}
                register={register}
                dataTestId='input-restocking-address-test-id'
                inputName='addressCode'
                type='text'
                errorMessage={errors.addressCode?.message}
                backgroundColor='lightGray'
              />
            </S.ContainerInput>
          </>
          <S.ContainerActions>
            <FormControlLabel
              control={(
                <Checkbox
                  checked={fifoCompleted}
                  onChange={handleFifoChange}
                  inputProps={{ 'data-testid': 'fifo-checkbox-test-id' } as React.InputHTMLAttributes<HTMLInputElement>}
                  disabled={!isRestockAddressValid}
                />
                    )}
              label='Realizei o FIFO na reposição'
            />
            <S.ContainerButton>
              <S.CustomButton
                title='Cancelar'
                bgColor='cancel'
                hoverColor='cancelHover'
                letterColor='white'
                data-testid='cancel-button-test-id'
                onClick={closeModal}
              />
              <S.CustomButton
                title='Confirmar'
                bgColor='confirm'
                hoverColor='confirmHover'
                letterColor='white'
                data-testid='confirm-button-test-id'
                disabled={!fifoCompleted}
                onClick={onConfirm}
              />
            </S.ContainerButton>
          </S.ContainerActions>
        </S.Container>
      )}
    />
  )
}

export default RestockingConfirmationModal
